import messengerReducer from "./messengerSlice";

export default messengerReducer;
